exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".font-shadow-sm[data-v-9db60e6e] {\n  text-shadow: 5px 5px 13px rgba(0,0,0,0.2);\n}\n", ""]);

// exports
